import React from 'react'
import { createPortal } from 'react-dom'
import MobileNav from './mobileNav';
import { useNavContext } from '../contexts/navContext';

export default function MobileHeader() {
    const toggler = useNavContext()
    const toggleMenu = ()=>{
        toggler.toggle ? toggler.setToggle(false) : toggler.setToggle(true)
    }


  return createPortal(
    <header className="mobile-header px-4 py-2">
        <div className="logo fw-bold">devFrank</div>
        <div className={`${toggler.toggle ? "ham active" : "ham"}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <MobileNav />
    </header>, document.body
  )
}
